import React from 'react';
import { FiverrProLogo } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import { StepWrapper as CoreStepWrapper } from '@fiverr-private/identification_core';
import { useStepsContext } from '../../StepsContext';
import { StepBanner } from '../StepBanner';
import { Disclaimer } from './Disclaimer';

interface Props {
    children: JSX.Element;
    illustration?: JSX.Element;
    showDisclaimer?: boolean;
    hideCloseBtn?: React.ComponentProps<typeof CoreStepWrapper>['hideCloseBtn'];
}

export const StepWrapper = ({
    children,
    illustration = <StepBanner />,
    showDisclaimer = false,
    hideCloseBtn,
}: Props) => {
    const { goBack, hasBack } = useStepsContext();

    return (
        <CoreStepWrapper
            fiverrLogo={
                <Container transform="scale(0.86) translateX(-10px)">
                    <FiverrProLogo />
                </Container>
            }
            illustration={illustration}
            illustrationLeftSide
            disclaimer={<Disclaimer />}
            showDisclaimer={showDisclaimer}
            hideCloseBtn={hideCloseBtn}
            goBack={goBack}
            hasBack={hasBack}
        >
            {children}
        </CoreStepWrapper>
    );
};
